<div class="tw-flex tw-max-h-[min(80vh,36rem)] tw-flex-col tw-gap-4 tw-text-center">
  <header class="tw-flex tw-shrink-0 tw-flex-col tw-items-center tw-gap-3">
    <img
      alt=""
      class="tw-h-[7.5rem] tw-w-auto"
      src="assets/images/icons/modal/notify.svg"
    />
    <h5
      *ngIf="messages.length > 1"
      class="tw-m-0 smsir-h5-lg tw-text-[rgb(var(--text-primary))]"
    >
      {{ modalHeader }}
    </h5>
    <h5
      *ngIf="messages.length === 1"
      class="tw-m-0 smsir-h5-lg tw-text-[rgb(var(--text-primary))]"
    >
      {{ messages[0].title }}
    </h5>
  </header>

  <div class="tw-min-h-0 tw-flex-1 tw-overflow-y-auto tw-text-right">
    <ul
      *ngIf="messages.length > 1"
      class="tw-m-0 tw-flex tw-list-disc tw-flex-col tw-gap-2 tw-pe-5 tw-ps-0 smsir-helper-lg tw-leading-6 tw-text-[rgb(var(--text-secondary))]"
    >
      <li *ngFor="let item of messages" [innerText]="item.content"></li>
    </ul>
    <p
      *ngIf="messages.length === 1"
      class="tw-m-0 smsir-helper-lg tw-leading-6 tw-text-[rgb(var(--text-secondary))]"
      [innerText]="messages[0].content"
    ></p>
  </div>

  <div class="tw-flex tw-shrink-0 tw-w-full tw-justify-center">
    <button
      type="button"
      smsir-button
      httpLoading
      variant="secondary"
      size="md"
      class="tw-min-w-[8.5rem]"
      (click)="onSubmit()"
    >
      متوجه شدم
    </button>
  </div>
</div>
